import Table from '../components/shared/table';
import Page from './page';
import PageHelper from '../helpers/page-helper';
import SearchForm from '../model/search-form';
import MessageHelper from '../helpers/message-helper';

export default abstract class AbstractAsyncTablePage extends Page {
  protected abstract readonly searchForm: SearchForm;
  protected abstract readonly table: Table;
  protected abstract readonly tableColumnDefinitions: DataTables.ColumnDefsSettings[];

  protected bindAsyncData(): void {
    this.searchForm.getForm().ajaxForm({
      dataType: 'json',
      beforeSubmit: (formData: { name: string, value: string }[]) => {
        const urlParams = new URLSearchParams();

        formData
          .filter(({ value }) => (value?.length > 1))
          .forEach(({
            name,
            value,
          }) => {
            urlParams.set(name, value);
          });

        window.history.pushState(null, document.title, `?${urlParams.toString()}`);
        PageHelper.showLoadingIndicator();
        return true;
      },
      success: (response: unknown[]) => {
        PageHelper.clearLoadingIndicator();
        this.setRows(response);
      },
      error: (response: unknown) => {
        PageHelper.clearLoadingIndicator();
        if (typeof response === 'string') {
          const errorMessage = JSON.parse(response) as string;
          window.NotificationHelper.showError(errorMessage);
        } else {
          window.NotificationHelper.showError(MessageHelper.getMessage('eparts.sap.file.search.service.error'));
        }
      },
    });
    this.searchForm.submit();
  }

  protected setRows(data: unknown[]): void {
    if (Array.isArray(data)) {
      this.table.setRows(data);
    }
  }
}
